import { Box, Stack, Typography } from "@mui/material";
import QueryIcon from "assets/svg/QueryIcon";
import { AxiosError, AxiosResponse } from "axios";
import { commonStyle } from "pages/Dashboard/common.styles";
import { useEffect, useState } from "react";
import {
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";
import { PieWeeklyGraphResponse } from "reduxStore/dataTypes";
import { fetchWeeklyRatio } from "services/apiService";
import theme, { responsiveFontSize } from "themes/Theme";

const TransactionRatio = () => {
  const [weeklyData, setWeeklyData] = useState<any[] | null>(null);
  const [noDataFound, setNoDataFound] = useState(false);
  const COLORS = ["#0f5051", "#2edadc"];

  const getPieGraphData = async () => {
    try {
      const response: AxiosResponse<PieWeeklyGraphResponse> =
        await fetchWeeklyRatio();
      if (response && response.status === 200) {
        if (
          Number(response?.data?.data?.receiveRatio) === 0 &&
          Number(response?.data?.data?.transferRatio) === 0
        ) {
          setNoDataFound(true);
        } else {
          const data = [
            {
              name: "Receive",
              value: Number(response?.data?.data?.receiveRatio),
            },
            {
              name: "Transfer",
              value: Number(response?.data?.data?.transferRatio),
            },
          ];
          setNoDataFound(false);
          setWeeklyData(data);
        }
      }
    } catch (error) {
      setNoDataFound(true);
      if (error instanceof AxiosError) {
        console.log(error?.response?.data?.message);
      }
    }
  };
  useEffect(() => {
    getPieGraphData();
  }, []);

  const renderLabel = ({ name, value }: { name: string; value: number }) => {
    return `${value}%`;
  };

  return (
    <Box sx={commonStyle.cardStyle}>
      <Stack direction={"row"} alignItems={"center"} gap={1} mb={2}>
        <Typography sx={commonStyle.cardTitleText}>
          Transaction Ratio
        </Typography>
      </Stack>

      {noDataFound ? (
        <Typography
          sx={{
            height: 280,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: theme.palette.text.secondary,
            fontSize: responsiveFontSize(16),
          }}
        >
          No Data Available
        </Typography>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={weeklyData || []}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={100}
              label={renderLabel}
            >
              {weeklyData?.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip
              formatter={(value: number, name: string) => {
                return [`${value}%`, name];
              }}
            />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      )}
    </Box>
  );
};
export default TransactionRatio;
